/* eslint no-underscore-dangle: 0 */
// Rollout configuration
import {pushDataLayer} from '@optimaxdev/analytics/mobile';
import {Rox} from 'rox-ssr';
import sessionStorage from 'store/storages/sessionStorage';

import {SESSION_STORAGE_FLAG_ANALYTICS_LIST} from 'constants/analytics/storages';
import rolloutKeys from 'constants/flags/keys';
import {ENVIRONMENT} from 'constants/app';
import flags from 'constants/flags/flags';

export const config = {
    impressionHandler: (reporting, experiment) => {
        // prevent repotring flags to analytics before flags configuration
        // fetched or loaded from cache or if flag hasn't experiment
        const isExperimentAvailableForAnalytics =
            !experiment?.isArchived && experiment?.labels?.includes('analytics');

        if (experiment && isExperimentAvailableForAnalytics) {
            const flagEventsList = JSON.parse(
                sessionStorage.read(SESSION_STORAGE_FLAG_ANALYTICS_LIST) || '{}',
            );
            if (
                flagEventsList[experiment.name] &&
                flagEventsList[experiment.name] === reporting.value
            )
                return;

            flagEventsList[experiment.name] = reporting.value;
            sessionStorage.write(
                SESSION_STORAGE_FLAG_ANALYTICS_LIST,
                JSON.stringify(flagEventsList),
            );

            pushDataLayer({
                event: 'GAEventGenericTriggerNonInteraction',
                eventCategory: 'flag',
                eventAction: experiment.name,
                eventLabel: reporting.value,
            });
        }
    },
};

// Show Rollout widget with all flags and their state
window.__showRolloutFlags = () => Rox.showOverrides();

/**
 * Initialize Rollout flags
 */
export const initRollout = async () => {
    Rox.register('', flags);
    await Rox.setup(rolloutKeys[ENVIRONMENT || 'production'], __NODEJS__ ? {} : config);
};
